var styles = {"box":"SectionTitle_box_q1tfs_1","margin-bottom":"SectionTitle_margin-bottom_q1tfs_7","title":"SectionTitle_title_q1tfs_10","description":"SectionTitle_description_q1tfs_28","buttons":"SectionTitle_buttons_q1tfs_39"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
